<template>
  <div>
    <router-link v-if="!$store.getters.getUser"
                 class="mr-4"
                 tag="span"
                 to="/application/signIn"
    >
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-login</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.login") }}</span>
      </span>
    </router-link>
    <router-link v-if="$store.getters.getUser" class="mr-4" tag="span" to="/import-item">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-file-import</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.import") }}</span>
      </span>
    </router-link>
    <router-link v-if="$store.getters.getUser" class="mr-4" tag="span" to="/export-item">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-file-export</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.export") }}</span>
      </span>
    </router-link>
    <router-link v-if="$store.getters.getUser"
                 class="mr-4"
                 tag="span"
                 to="/application/signOut"
    >
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>power_settings_new</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.logout") }}</span>
      </span>
    </router-link>
    <!-- PRIMARY NAV BUTTONS -->
    <v-divider></v-divider>
    <template v-if="userHasAuth()">
      <router-link class="mr-4" tag="span" to="/items">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-cube-scan</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.items") }}</span>
      </span>
      </router-link>
    </template>
    <router-link v-if="userHasRole([UserRoleWithPrefix.ROLE_ADMIN, UserRoleWithPrefix.ROLE_DEV])" class="mr-4"
                 tag="span"
                 to="/users">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-account-multiple</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.users") }}</span>
      </span>
    </router-link>
    <router-link v-if="userHasRole([UserRoleWithPrefix.ROLE_ADMIN, UserRoleWithPrefix.ROLE_DEV])" class="mr-4"
                 tag="span"
                 to="/settings">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-cogs</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.settings") }}</span>
      </span>
    </router-link>
    <router-link v-if="userHasRole([UserRoleWithPrefix.ROLE_ADMIN, UserRoleWithPrefix.ROLE_DEV])" class="mr-4"
                 tag="span"
                 to="/errors">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>dangerous</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.errors") }}</span>
      </span>
    </router-link>
    <router-link v-if="userHasRole([UserRoleWithPrefix.ROLE_ADMIN, UserRoleWithPrefix.ROLE_DEV])" class="mr-4"
                 tag="span"
                 to="/error-logs">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>insert_invitation</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.errorLog") }}</span>
      </span>
    </router-link>
    <router-link class="mr-4" tag="span" to="/info">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>info</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.info") }}</span>
      </span>
    </router-link>

    <!-- Admin environment -->
    <template v-if="userHasRole([UserRoleWithPrefix.ROLE_ADMIN, UserRoleWithPrefix.ROLE_DEV])">
      <!-- DIAGNOSTICS -->
      <v-divider></v-divider>
      <router-link class="mr-4" tag="span" to="/log-viewer">
        <span class="btn-round-text" @click="closeOverlay()">
          <v-btn fab x-large>
            <v-icon>description</v-icon>
          </v-btn>
          <span>{{ $t("global.menu.logs") }}</span>
        </span>
      </router-link>
    </template>
    <!-- System Control buttons -->
    <v-divider></v-divider>
    <span class="mr-4">
        <span class="btn-round-text" @click="restartApplication">
          <v-btn fab x-large>
            <v-icon>mdi-restart</v-icon>
          </v-btn>
          <span>{{ $t("global.menu.restart") }}</span>
        </span>
      </span>
    <span class="mr-4">
        <span class="btn-round-text" @click="shutdownApplication">
          <v-btn fab x-large>
            <v-icon>mdi-power</v-icon>
          </v-btn>
          <span>{{ $t("global.menu.shutdown") }}</span>
        </span>
      </span>
  </div>
</template>


<script>
import {EVENTBUS_TOPICS} from "@/lib/constants";
import {EventBus} from "@/lib/event-bus";
import {UserRoleWithPrefix} from "@/components/users/model/UserRoleWithPrefix";
import axios from "axios";

export default {
  name: "navigation-items",
  computed: {
    UserRoleWithPrefix() {
      return UserRoleWithPrefix;
    }
  },
  components: {},
  methods: {
    closeOverlay() {
      EventBus.$emit(EVENTBUS_TOPICS.SHOW_OVERLAY, false);
    },
    restartApplication() {
      if (confirm("Are you sure you want to restart the application?")) {
        // Show a loading dialog or notification
        this.$store.commit('setLoading', true);

        // Call backend API to restart the application
        axios.post('/frontend-api/restart')
          .then(() => {
            // Display a message that the system is restarting
            this.$store.commit('setSnackbar', {
              text: 'Application is restarting. Please wait...',
              color: 'info',
              timeout: -1
            });

            // Check when the application is back online
            this.checkServerStatus();
          })
          .catch(error => {
            console.error('Failed to restart application:', error);
            this.$store.commit('setLoading', false);
            this.$store.commit('setSnackbar', {
              text: 'Failed to restart application',
              color: 'error'
            });
          });
      }
    },
    shutdownApplication() {
      if (confirm("Are you sure you want to shutdown the application?")) {
        // Call backend API to shutdown the application
        axios.post('/frontend-api/shutdown')
          .then(() => {
            this.$store.commit('setSnackbar', {
              text: 'Application is shutting down...',
              color: 'info',
              timeout: 5000
            });
          })
          .catch(error => {
            console.error('Failed to shutdown application:', error);
            this.$store.commit('setSnackbar', {
              text: 'Failed to shutdown application',
              color: 'error'
            });
          });
      }
    },
    checkServerStatus() {
      const checkInterval = setInterval(() => {
        axios.get('/frontend-api/health')
          .then(() => {
            clearInterval(checkInterval);
            this.$store.commit('setLoading', false);
            this.$store.commit('setSnackbar', {
              text: 'Application has restarted successfully',
              color: 'success'
            });
            // Reload the page
            window.location.reload();
          })
          .catch(() => {
            // Still restarting, continue checking
          });
      }, 2000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.current-menu-item button {
  color: $inther-orange;
}
</style>
